function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_2016",
  "data-name": "Grupo 2016",
  transform: "translate(-3.316 -5.817)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_1217",
  "data-name": "Caminho 1217",
  d: "M14.458,30.577l-1.7-1.433,1.538-1.538-.781-3.757-4.238.1-.006-.278,4.469-.1L14.6,27.7l-1.43,1.43,1.266,1.066,1.506-1.65-.8-5.833-3.584-1.536.563-2.936L11.685,15.6l1.88-3.677,1.247,1.692.574,3.558,1.259.108,1.348.142L18.8,9.49l.887-1.658-.182-.821-1.69.955L14.9,6.862l-2.9.42L6.444,10.691a2.074,2.074,0,0,1-.808,1.135,4.041,4.041,0,0,1-1.718.582l-.038-.275a3.776,3.776,0,0,0,1.6-.538,1.793,1.793,0,0,0,.708-1.028l.014-.055,5.695-3.5,3.032-.439L17.792,7.66l1.9-1.076.286,1.288-.909,1.7-.832,8.156-1.622-.171-1.472-.126-.6-3.706-.94-1.276-1.634,3.2.426,2.6-.53,2.765,3.523,1.51.84,6.117Z",
  transform: "translate(0)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
}));

function SvgMeetings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.194,
    height: 25.452,
    viewBox: "0 0 17.194 25.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetings);
export default __webpack_public_path__ + "static/media/meetings.0e1f2399.svg";
export { ForwardRef as ReactComponent };